var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.53 3.1877c-.2931-.7083-1.0663-1.0854-1.8051-.8835l-3.3514.914c-.6627.1828-1.1235.7845-1.1235 1.47 0 9.4221 7.6397 17.0618 17.0617 17.0618.6856 0 1.2873-.4608 1.4701-1.1235l.914-3.3514c.2019-.7388-.1752-1.5119-.8835-1.8052l-3.6561-1.5234c-.6208-.2589-1.3406-.0799-1.7633.4418l-1.5386 1.8776c-2.6812-1.2682-4.852-3.439-6.1202-6.1202l1.8776-1.5348a1.52 1.52 0 0 0 .4418-1.7633l-1.5234-3.656z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-icon.79e8a3fe38e199649d733e28fdecff64.svg";